import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { OpenRollfiPayroll } from 'domain/usecases';

import { RemoteOpenRollfiPayroll } from 'data/usecases/rollfi';

export const makeOpenRollfiPayroll = (): OpenRollfiPayroll => {
  return new RemoteOpenRollfiPayroll(makeApiUrl('/rollfi/open-payroll'), makeAuthorizeHttpClientDecorator());
};
